.resetInput {
  border: none;
  padding: 0 0.5rem;
  outline: none;
  width: 100%;
  color: #55595c;
}

.input {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  &::before {
    content: "£";
    display: block;
  }
}
